"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMobileBottomNavItems = exports.getMobileNavigationItems = exports.getMarketingNavItems = exports.getMobileNavV2Items = exports.getConsumerNavItems = exports.CREATE_STORY_LINK = exports.DOWNLOAD_LINK = exports.HOME_LINK_TITLE = exports.HOME_LINK = void 0;
const ChatIcon_1 = require("./components/icons/ChatIcon");
const LensesIcon_1 = require("./components/icons/LensesIcon");
const MapsIcon_1 = require("./components/icons/MapsIcon");
const SpotlightIcon_1 = require("./components/icons/SpotlightIcon");
const StoriesIcon_1 = require("./components/icons/StoriesIcon");
const datatypes_1 = require("./datatypes");
const ChatIcon_2 = require("./components/icons/mobile/v2/ChatIcon");
const LensesIcon_2 = require("./components/icons/mobile/v2/LensesIcon");
const MapsIcon_2 = require("./components/icons/mobile/v2/MapsIcon");
const SpotlightIcon_2 = require("./components/icons/mobile/v2/SpotlightIcon");
const StoriesIcon_2 = require("./components/icons/mobile/v2/StoriesIcon");
exports.HOME_LINK = "https://www.snapchat.com/";
exports.HOME_LINK_TITLE = "Snapchat";
exports.DOWNLOAD_LINK = "https://www.snapchat.com/download/";
const PRIVACY_CHOICES_LINK = "https://help.snapchat.com/hc/articles/11399265637012?utm_source=snapchat_com&utm_medium=global_footer&utm_campaign=privacy_choices";
exports.CREATE_STORY_LINK = {
    title: "Post to Snapchat",
    // params used for tracking, issue: https://jira.sc-corp.net/browse/WEB-1414
    link: "https://my.snapchat.com/?utm_source=consumer_web&utm_content=nav_post_button",
    label: datatypes_1.DesktopNavItemType.CREATE_STORY_LINK,
};
const getConsumerNavItems = (intl) => [
    {
        link: "https://www.snapchat.com/discover",
        Icon: StoriesIcon_1.StoriesIcon,
        label: datatypes_1.DesktopNavItemType.STORIES,
        title: intl.formatMessage({
            id: "1JAbNA",
            defaultMessage: "Stories",
            description: "Stories Nav Item",
        }),
        id: datatypes_1.ConsumerApp.Stories,
    },
    {
        link: "https://www.snapchat.com/spotlight",
        Icon: SpotlightIcon_1.SpotlightIcon,
        label: datatypes_1.DesktopNavItemType.SPOTLIGHT,
        title: "Spotlight",
        id: datatypes_1.ConsumerApp.Spotlight,
    },
    {
        link: "https://web.snapchat.com/?ref=web_nav_chat_icon",
        Icon: ChatIcon_1.ChatIcon,
        label: datatypes_1.DesktopNavItemType.CHAT,
        title: intl.formatMessage({
            id: "u6AK3M",
            defaultMessage: "Chat",
            description: "WebChat Nav Item",
        }),
        id: datatypes_1.ConsumerApp.Chat,
        isNew: true,
        openInNewTab: true,
    },
    {
        link: "https://www.snapchat.com/lens",
        Icon: LensesIcon_1.LensesIcon,
        label: datatypes_1.DesktopNavItemType.LENS,
        title: intl.formatMessage({
            id: "2iEYAu",
            defaultMessage: "Lenses",
            description: "Lenses Navigation Item Name",
        }),
        id: datatypes_1.ConsumerApp.Lens,
    },
    {
        link: "https://map.snapchat.com",
        Icon: MapsIcon_1.MapIcon,
        label: datatypes_1.DesktopNavItemType.MAP,
        title: intl.formatMessage({
            id: "/o4FtQ",
            defaultMessage: "Map",
            description: "Map Nav Item",
        }),
        id: datatypes_1.ConsumerApp.Map,
    },
];
exports.getConsumerNavItems = getConsumerNavItems;
const getMobileNavV2Items = (intl, chatIconLink) => [
    {
        link: "https://map.snapchat.com",
        Icon: MapsIcon_2.MapIcon,
        label: datatypes_1.MobileNavItemType.MAP,
        title: intl.formatMessage({
            id: "/o4FtQ",
            defaultMessage: "Map",
            description: "Map Nav Item",
        }),
        id: datatypes_1.ConsumerApp.Map,
    },
    {
        link: chatIconLink,
        Icon: ChatIcon_2.ChatIcon,
        label: datatypes_1.MobileNavItemType.CHAT,
        title: intl.formatMessage({
            id: "u6AK3M",
            defaultMessage: "Chat",
            description: "WebChat Nav Item",
        }),
        id: datatypes_1.ConsumerApp.Chat,
        openInNewTab: true,
    },
    {
        link: "https://www.snapchat.com/lens",
        Icon: LensesIcon_2.LensesIcon,
        label: datatypes_1.MobileNavItemType.LENS,
        title: intl.formatMessage({
            id: "2iEYAu",
            defaultMessage: "Lenses",
            description: "Lenses Navigation Item Name",
        }),
        id: datatypes_1.ConsumerApp.Lens,
    },
    {
        // temporarily using link. due to android being broken
        // todo: switch back post-fix: https://jira.sc-corp.net/browse/WEB-3166
        link: "https://link.snapchat.com/discover",
        Icon: StoriesIcon_2.StoriesIcon,
        label: datatypes_1.MobileNavItemType.STORIES,
        title: intl.formatMessage({
            id: "1JAbNA",
            defaultMessage: "Stories",
            description: "Stories Nav Item",
        }),
        id: datatypes_1.ConsumerApp.Stories,
    },
    {
        link: "https://www.snapchat.com/spotlight",
        Icon: SpotlightIcon_2.SpotlightIcon,
        label: datatypes_1.MobileNavItemType.SPOTLIGHT,
        title: "Spotlight",
        id: datatypes_1.ConsumerApp.Spotlight,
    },
];
exports.getMobileNavV2Items = getMobileNavV2Items;
const getMarketingNavItems = (intl) => [
    {
        title: "Snapchat.com",
        items: [
            {
                title: intl.formatMessage({
                    id: "lH1D9c",
                    defaultMessage: "Overview",
                    description: "Overview Marketing Nav Item",
                }),
                id: "Overview",
                link: "https://www.snapchat.com",
                label: datatypes_1.DesktopNavItemType.SNAPCHAT_OVERVIEW,
            },
            {
                title: intl.formatMessage({
                    id: "LXGd0Z",
                    defaultMessage: "Accounts",
                    description: "Account Marketing Nav Item",
                }),
                id: "Accounts",
                link: "https://accounts.snapchat.com",
                label: datatypes_1.DesktopNavItemType.ACCOUNTS,
            },
            {
                title: "Snapchat Plus",
                id: "Snapchat Plus",
                link: "https://www.snapchat.com/plus",
                label: datatypes_1.DesktopNavItemType.SNAPCHAT_PLUS,
            },
            {
                id: "Support",
                title: intl.formatMessage({
                    id: "QLSvWU",
                    defaultMessage: "Support",
                    description: "Support Marketing Nav Item",
                }),
                link: "https://help.snapchat.com",
                label: datatypes_1.DesktopNavItemType.SNAPCHAT_SUPPORT,
            },
            {
                id: "Privacy and Safety",
                title: intl.formatMessage({
                    id: "d1Fnt+",
                    defaultMessage: "Privacy and Safety",
                    description: "Privacy and Safety Nav Item",
                }),
                link: "https://values.snap.com",
                label: datatypes_1.DesktopNavItemType.PRIVACY_AND_SAFETY,
            },
            {
                id: "Your Privacy Choices",
                title: intl.formatMessage({
                    id: "PLjvWf",
                    defaultMessage: "Your Privacy Choices",
                    description: "Your Privacy Choices Marketing Nav Item",
                }),
                link: PRIVACY_CHOICES_LINK,
                label: datatypes_1.DesktopNavItemType.YOUR_PRIVACY_CHOICES,
            },
        ],
    },
    {
        title: intl.formatMessage({
            id: "milYa0",
            defaultMessage: "Business",
            description: "Business Nav Item",
        }),
        items: [
            {
                title: intl.formatMessage({
                    id: "cdFMt7",
                    defaultMessage: "For Business",
                    description: "For Business Marketing Nav Item",
                }),
                id: "For Business",
                link: "https://forbusiness.snapchat.com",
                label: datatypes_1.DesktopNavItemType.FOR_BUSINESS,
            },
            {
                title: intl.formatMessage({
                    id: "vXHzz1",
                    defaultMessage: "Ads Manager",
                    description: "Ads Manager Marketing Nav Item",
                }),
                id: "Ads Manager",
                link: "https://ads.snapchat.com",
                label: datatypes_1.DesktopNavItemType.ADS_MANAGER,
            },
            {
                title: intl.formatMessage({
                    id: "NaulaK",
                    defaultMessage: "Business Support",
                    description: "Business Support Marketing Nav Item",
                }),
                id: "Business Support",
                link: "https://businesshelp.snapchat.com",
                label: datatypes_1.DesktopNavItemType.BUSINESS_SUPPORT,
            },
        ],
    },
    {
        title: "Snap AR",
        items: [
            {
                title: "Lens Studio",
                id: "Lens Studio",
                link: "https://ar.snap.com/lens-studio",
                label: datatypes_1.DesktopNavItemType.LENS_STUDIO,
            },
        ],
    },
    {
        title: intl.formatMessage({
            id: "67xqDn",
            defaultMessage: "Creator",
            description: "Creator Marketing Nav Item",
        }),
        items: [
            {
                title: intl.formatMessage({
                    id: "Xrm52A",
                    defaultMessage: "For Creators",
                    description: "For Creators Nav Item",
                }),
                id: "For Creators",
                link: "https://creators.snap.com",
                label: datatypes_1.DesktopNavItemType.CREATOR,
            },
        ],
    },
    {
        title: intl.formatMessage({
            id: "15sbQK",
            defaultMessage: "Developers",
            description: "Developers Nav Item",
        }),
        items: [
            {
                title: intl.formatMessage({
                    id: "UrD/sz",
                    defaultMessage: "For developers",
                    description: "For developers Marketing Nav Item",
                }),
                id: "For developers",
                link: "https://developers.snap.com",
                label: datatypes_1.DesktopNavItemType.FOR_DEVELOPERS,
            },
            {
                title: "Playcanvas",
                id: "Playcanvas",
                link: "https://playcanvas.com",
                label: datatypes_1.DesktopNavItemType.PLAYCANVAS,
            },
        ],
    },
    {
        title: "Spectacles",
        items: [
            {
                title: intl.formatMessage({
                    id: "lH1D9c",
                    defaultMessage: "Overview",
                    description: "Overview Marketing Nav Item",
                }),
                id: "Overview",
                link: "https://www.spectacles.com",
                label: datatypes_1.DesktopNavItemType.SPECTACLES_OVERVIEW,
            },
            {
                title: intl.formatMessage({
                    id: "67xqDn",
                    defaultMessage: "Creator",
                    description: "Creator Marketing Nav Item",
                }),
                id: "Creator",
                link: "https://www.spectacles.com/creators",
                label: datatypes_1.DesktopNavItemType.SPECTACLES_CREATOR,
            },
            {
                title: `Spectacles ${intl.formatMessage({
                    id: "FobC0E",
                    defaultMessage: "Support",
                    description: "Spectacles Support Marketing Nav Item",
                })}`,
                id: "Spectacles Support",
                link: "https://support.spectacles.com",
                label: datatypes_1.DesktopNavItemType.SPECTACLES_SUPPORT,
            },
        ],
    },
];
exports.getMarketingNavItems = getMarketingNavItems;
const getMobileNavigationItems = (intl) => [
    {
        title: intl.formatMessage({
            id: "TU8E7s",
            defaultMessage: "Features",
            description: "Features Nav Link Group",
        }),
        id: "Features",
        items: [
            {
                title: intl.formatMessage({
                    id: "1JAbNA",
                    defaultMessage: "Stories",
                    description: "Stories Nav Item",
                }),
                id: datatypes_1.ConsumerApp.Stories,
                link: "https://www.snapchat.com/discover",
                label: datatypes_1.MobileNavItemType.STORIES,
            },
            {
                title: "Spotlight",
                id: datatypes_1.ConsumerApp.Spotlight,
                link: "https://www.snapchat.com/spotlight",
                label: datatypes_1.MobileNavItemType.SPOTLIGHT,
            },
            {
                title: intl.formatMessage({
                    id: "2iEYAu",
                    defaultMessage: "Lenses",
                    description: "Lenses Navigation Item Name",
                }),
                id: datatypes_1.ConsumerApp.Lens,
                link: "https://www.snapchat.com/lens",
                label: datatypes_1.MobileNavItemType.LENS,
            },
            {
                title: intl.formatMessage({
                    id: "/o4FtQ",
                    defaultMessage: "Map",
                    description: "Map Nav Item",
                }),
                id: datatypes_1.ConsumerApp.Map,
                link: "https://map.snapchat.com",
                label: datatypes_1.MobileNavItemType.MAP,
            },
        ],
    },
    {
        title: intl.formatMessage({
            id: "dhrOUZ",
            defaultMessage: "Accounts",
            description: "Accounts Nav Item",
        }),
        id: "Accounts",
        link: "https://accounts.snapchat.com",
        label: datatypes_1.MobileNavItemType.ACCOUNTS,
    },
    {
        title: "Snapchat Plus",
        id: "Snapchat Plus",
        link: "https://www.snapchat.com/plus",
        label: datatypes_1.MobileNavItemType.SNAPCHAT_PLUS,
    },
    {
        title: intl.formatMessage({
            id: "tjEfLW",
            defaultMessage: "Support",
            description: "Support Nav Item",
        }),
        id: "Support",
        link: "https://help.snapchat.com",
        label: datatypes_1.MobileNavItemType.SNAPCHAT_SUPPORT,
    },
    {
        title: intl.formatMessage({
            id: "LWQk4A",
            defaultMessage: "Ads",
            description: "Ads Nav Item",
        }),
        id: "Ads",
        link: "https://forbusiness.snapchat.com",
        label: datatypes_1.MobileNavItemType.ADS,
    },
    {
        title: intl.formatMessage({
            id: "Ja6NcZ",
            defaultMessage: "Download",
            description: "Download Nav Item",
        }),
        id: "Download",
        link: "https://www.snapchat.com/download",
        label: datatypes_1.MobileNavItemType.DOWNLOAD,
    },
    {
        title: intl.formatMessage({
            id: "YYQ8/E",
            defaultMessage: "Cookie Policy",
            description: "Cookie Policy Nav Item",
        }),
        id: "Cookie Policy",
        link: "https://snap.com/en-US/cookie-policy",
        label: datatypes_1.MobileNavItemType.COOKIE_POLICY,
    },
    {
        title: intl.formatMessage({
            id: "7cBPZM",
            defaultMessage: "Privacy Policy",
            description: "Privacy Policy Nav Item",
        }),
        id: "Privacy Policy",
        link: "https://snap.com/privacy/privacy-policy",
        label: datatypes_1.MobileNavItemType.PRIVACY_POLICY,
    },
    {
        title: intl.formatMessage({
            id: "Gs4Z7K",
            defaultMessage: "Terms of Services",
            description: "Terms of Services Nav Item",
        }),
        id: "Terms of Services",
        link: "https://snap.com/terms",
        label: datatypes_1.MobileNavItemType.TERMS_OF_SERVICE,
    },
    {
        id: "Privacy and Safety",
        title: intl.formatMessage({
            id: "d1Fnt+",
            defaultMessage: "Privacy and Safety",
            description: "Privacy and Safety Nav Item",
        }),
        link: "https://values.snap.com",
        label: datatypes_1.MobileNavItemType.PRIVACY_AND_SAFETY,
    },
    {
        title: intl.formatMessage({
            id: "JJQ8/E",
            defaultMessage: "Your Privacy Choices",
            description: "Your Privacy Choices Nav Item",
        }),
        id: "Your Privacy Choices",
        link: PRIVACY_CHOICES_LINK,
        label: datatypes_1.MobileNavItemType.YOUR_PRIVACY_CHOICES,
    },
];
exports.getMobileNavigationItems = getMobileNavigationItems;
const getMobileBottomNavItems = (intl) => [
    {
        title: intl.formatMessage({
            id: "milYa0",
            defaultMessage: "Business",
            description: "Business Nav Item",
        }),
        id: "Business",
        items: [
            {
                title: intl.formatMessage({
                    id: "5lirL/",
                    defaultMessage: "For Business",
                    description: "For Business Nav Item",
                }),
                id: "For Business",
                link: "https://forbusiness.snapchat.com",
                label: datatypes_1.MobileNavItemType.FOR_BUSINESS,
            },
            {
                title: intl.formatMessage({
                    id: "tv+T1h",
                    defaultMessage: "Ads Manager",
                    description: "Ads Manager Nav Item",
                }),
                id: "Ads Manager",
                link: "https://ads.snapchat.com",
                label: datatypes_1.MobileNavItemType.ADS_MANAGER,
            },
            {
                title: intl.formatMessage({
                    id: "khZ+z6",
                    defaultMessage: "Snap Publisher",
                    description: "Snap Publisher Nav Item",
                }),
                id: "Snap Publisher",
                link: "https://snappublisher.snapchat.com",
                label: datatypes_1.MobileNavItemType.SNAP_PUBLISHER,
            },
            {
                title: intl.formatMessage({
                    id: "H2xi8I",
                    defaultMessage: "Business Support",
                    description: "Business Support Nav Item",
                }),
                id: "Business Support",
                link: "https://businesshelp.snapchat.com",
                label: datatypes_1.MobileNavItemType.BUSINESS_SUPPORT,
            },
            {
                title: intl.formatMessage({
                    id: "1TqZE7",
                    defaultMessage: "Public Profiles for Business",
                    description: "Public Profiles for Business Nav Item",
                }),
                id: "Public Profiles for Business",
                link: "https://forbusiness.snapchat.com/public-profiles",
                label: datatypes_1.MobileNavItemType.PUBLIC_PROFILES_FOR_BUSINESS,
            },
        ],
    },
    {
        title: "Snap AR",
        id: "Snap AR",
        items: [
            {
                id: "Snap AR",
                title: intl.formatMessage({
                    id: "milYa0",
                    defaultMessage: "Business",
                    description: "Business Nav Item",
                }),
                link: "https://ar.snap.com",
                label: datatypes_1.MobileNavItemType.SNAP_AR,
            },
            {
                id: "Lens Studio",
                title: "Lens Studio",
                link: "https://ar.snap.com/lens-studio",
                label: datatypes_1.MobileNavItemType.LENS_STUDIO,
            },
            {
                id: "Lens Web Builder",
                title: "Lens Web Builder",
                link: "https://ar.snap.com/lens-web-builder",
                label: datatypes_1.MobileNavItemType.LENS_WEB_BUILDER,
            },
            {
                id: "Camera Kit",
                title: "Camera Kit",
                link: "https://ar.snap.com/camera-kit",
                label: datatypes_1.MobileNavItemType.CAMERA_KIT,
            },
        ],
    },
    {
        title: "Pixy",
        id: "Pixy",
        items: [
            {
                title: `${intl.formatMessage({
                    id: "zjVcbH",
                    defaultMessage: "Shop",
                    description: "Shop Pixy Nav Item",
                })} Pixy`,
                id: "Shop Pixy",
                link: "https://pixy.com",
                label: datatypes_1.MobileNavItemType.SHOP_PIXY,
            },
            {
                title: `Pixy ${intl.formatMessage({
                    id: "MRRwTC",
                    defaultMessage: "Support",
                    description: "Pixy Support Nav Item",
                })}`,
                id: "Pixy Support",
                link: "https://support.pixy.com",
                label: datatypes_1.MobileNavItemType.PIXY_SUPPORT,
            },
        ],
    },
    {
        title: "Snap Inc.",
        id: "Snap Inc.",
        items: [
            {
                title: "Snap Inc.",
                id: "Snap Inc.",
                link: "https://snap.com",
                label: datatypes_1.MobileNavItemType.SNAP_INC,
            },
            {
                title: intl.formatMessage({
                    id: "MPfmoz",
                    defaultMessage: "Investors",
                    description: "Investors Nav Item",
                }),
                id: "Investors",
                link: "https://investor.snap.com",
                label: datatypes_1.MobileNavItemType.INVESTORS,
            },
            {
                title: intl.formatMessage({
                    id: "rx5d5k",
                    defaultMessage: "Careers",
                    description: "Careers Nav Item",
                }),
                id: "Careers",
                link: "https://careers.snap.com",
                label: datatypes_1.MobileNavItemType.CAREERS,
            },
            {
                title: intl.formatMessage({
                    id: "9VdhT5",
                    defaultMessage: "News",
                    description: "News Nav Item",
                }),
                id: "News",
                link: "https://newsroom.snap.com",
                label: datatypes_1.MobileNavItemType.NEWS,
            },
            {
                title: intl.formatMessage({
                    id: "rghIM3",
                    defaultMessage: "Safety & Impact",
                    description: "Safety & Impact Nav Item",
                }),
                id: "Safety & Impact",
                link: "https://snap.com/safety-and-impact",
                label: datatypes_1.MobileNavItemType.SAFETY_IMPACT,
            },
            {
                title: intl.formatMessage({
                    id: "ywboC7",
                    defaultMessage: "CitizenSnap",
                    description: "CitizenSnap Nav Item",
                }),
                id: "CitizenSnap",
                link: "https://citizen.snap.com",
                label: datatypes_1.MobileNavItemType.CITIZEN_SNAP,
            },
            {
                title: "Bitmoji",
                id: "Bitmoji",
                link: "https://www.bitmoji.com",
                label: datatypes_1.MobileNavItemType.BITMOJI,
            },
        ],
    },
    {
        title: intl.formatMessage({
            id: "fmKLYj",
            defaultMessage: "Creators",
            description: "Creators Nav Item",
        }),
        id: "Creators",
        items: [
            {
                title: intl.formatMessage({
                    id: "wvwh5b",
                    defaultMessage: "Creator Hub",
                    description: "Creator Hub Nav Item",
                }),
                id: "Creator Hub",
                link: "https://creators.snap.com",
                label: datatypes_1.MobileNavItemType.CREATOR_HUB,
            },
            {
                title: intl.formatMessage({
                    id: "BhoFmY",
                    defaultMessage: "Post to Spotlight",
                    description: "Post to Spotlight Nav Item",
                }),
                id: "Post to Spotlight",
                // params used for tracking, issue: https://jira.sc-corp.net/browse/WEB-1414
                link: "https://my.snapchat.com/?utm_source=consumer_web&utm_content=nav_submenu_post_button",
                label: datatypes_1.MobileNavItemType.POST_TO_SPOTLIGHT,
            },
        ],
    },
    {
        title: intl.formatMessage({
            id: "15sbQK",
            defaultMessage: "Developers",
            description: "Developers Nav Item",
        }),
        id: "Developers",
        items: [
            {
                title: intl.formatMessage({
                    id: "LITyBO",
                    defaultMessage: "For Developers",
                    description: "For Developers Nav Item",
                }),
                id: "For Developers",
                link: "https://developers.snap.com",
                label: datatypes_1.MobileNavItemType.FOR_DEVELOPERS,
            },
            {
                title: "PlayCanvas",
                id: "PlayCanvas",
                link: "https://playcanvas.com",
                label: datatypes_1.MobileNavItemType.PLAYCANVAS,
            },
            {
                title: intl.formatMessage({
                    id: "e7wSLn",
                    defaultMessage: "Marketing API",
                    description: "Marketing API Nav Item",
                }),
                id: "Marketing API",
                link: "https://marketingapi.snapchat.com",
                label: datatypes_1.MobileNavItemType.MARKETING_API,
            },
        ],
    },
    {
        title: "Spectacles",
        id: "Spectacles",
        items: [
            {
                title: "Spectacles",
                id: "Spectacles",
                link: "https://www.spectacles.com",
                label: datatypes_1.MobileNavItemType.SNAP_INC,
            },
            {
                title: intl.formatMessage({
                    id: "fmKLYj",
                    defaultMessage: "Creators",
                    description: "Creators Nav Item",
                }),
                id: "Creators",
                link: "https://www.spectacles.com/creators",
                label: datatypes_1.MobileNavItemType.CAREERS,
            },
            {
                title: intl.formatMessage({
                    id: "qhno3L",
                    defaultMessage: "Spectacles Support",
                    description: "Spectacles Support Nav Item",
                }),
                id: "Spectacles Support",
                link: "https://support.spectacles.com",
                label: datatypes_1.MobileNavItemType.NEWS,
            },
        ],
    },
];
exports.getMobileBottomNavItems = getMobileBottomNavItems;
//# sourceMappingURL=content.js.map